module.exports = __webpack_public_path__ + "img/5.ad457162.jpg";